import { apiClient } from "./client";

export interface RetainingWallsBuildUpItem {
  id: string;
  description: string;
  length?: number;
  width?: number;
  height?: number;
  net: number;
  unit: string;
  rate: number;
  labour: number;
  total: number;
}

export interface RetainingWallsBuildUpSpecification {
  id: string;
  name: string;
  type: string;
  category: string;
  items: RetainingWallsBuildUpItem[];
  netTotal: number;
  ohpPercent: number;
  ohpAmount: number;
  grandTotal: number;
  prelimsPercent?: number;
}

export interface RetainingWallsBuildUpConfig {
  facingBrickworkLabel?: string;
  screenWallsLabel?: string;
  eoPillarLabel?: string;
}

export interface RetainingWallsBuildUpRequest {
  tenderId: string;
  tenderName: string;
  tenderVersion: number;
  specifications: RetainingWallsBuildUpSpecification[];
  config?: RetainingWallsBuildUpConfig;
}

export interface RetainingWallsBuildUpResponse {
  success: boolean;
  message?: string;
}

export interface RetainingWallsBuildUpGetResponse {
  tenderId: string;
  tenderName: string;
  tenderVersion: number;
  specifications: RetainingWallsBuildUpSpecification[];
  config?: RetainingWallsBuildUpConfig;
}

export const retainingWallsBuildUpApi = {
  get: async (tenderName: string, tenderVersion: number): Promise<RetainingWallsBuildUpGetResponse | null> => {
    const response = await apiClient.get<RetainingWallsBuildUpGetResponse>(
      "/v3/retaining-walls-buildup",
      { params: { tenderName, tenderVersion } }
    );
    return response.data;
  },

  post: async (data: RetainingWallsBuildUpRequest): Promise<RetainingWallsBuildUpResponse> => {
    const response = await apiClient.post<RetainingWallsBuildUpResponse>(
      "/v3/retaining-walls-buildup",
      data
    );
    return response.data;
  },
};
